import React from 'react';
import { Bike, Package, Car } from 'lucide-react';
import { SERVICE_TYPES } from '../../../../constants';

export const ReviewVehicleIllustration = ({ serviceType }) => {
  if (serviceType === SERVICE_TYPES.DELIVERY || serviceType === SERVICE_TYPES.ERRAND) {
    return (
      <div className="w-100 d-flex justify-content-center align-items-center py-2">
        <Package size={48} style={{ color: 'var(--bry-accent, #0EABB0)' }} />
      </div>
    );
  }

  if (serviceType === 'car' || serviceType === 'AUTO') {
    return (
      <div className="w-100 d-flex justify-content-center align-items-center py-2">
        <Car size={48} style={{ color: 'var(--bry-accent, #0EABB0)' }} />
      </div>
    );
  }

  return (
    <div className="w-100 d-flex justify-content-center align-items-center py-2">
      <Bike size={48} style={{ color: 'var(--bry-accent, #0EABB0)' }} />
    </div>
  );
};

export default ReviewVehicleIllustration;
